<template>
  <v-app id="resetting_password">
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center" no-gutters>
          <v-col cols="12" sm="8" md="3">
            <ValidationObserver ref="forms">
              <v-form @submit.prevent="recover">
                <v-card class="elevation-12" :disabled="globalLoading">
                  <v-card-text class="card-text">
                    <h1 class="text-center mt-6 mb-10 primary--text">
                      Alterar senha
                    </h1>

                    <ValidationProvider
                      name="new_password"
                      rules="required|min:6"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        id="password"
                        label="New password"
                        name="new_password"
                        prepend-icon="mdi-lock"
                        v-model="password"
                        :error-messages="errors"
                        :disable="loading"
                        :type="show1 ? 'text' : 'password'"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="show1 = !show1"
                      />
                    </ValidationProvider>

                    <ValidationProvider
                      name="confirm_password"
                      :rules="{ required, is: password }"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        id="confirm_password"
                        label="Confirm new password"
                        name="confirm_password"
                        prepend-icon="mdi-lock"
                        v-model="confirm_password"
                        :error-messages="errors"
                        :disable="loading"
                        :type="show2 ? 'text' : 'password'"
                        :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="show2 = !show2"
                      />
                    </ValidationProvider>

                    <v-alert
                      type="error"
                      class="mt-2"
                      v-if="message"
                      text
                      icon="mdi-message-alert-outline"
                    >
                      {{ message }}
                    </v-alert>
                  </v-card-text>

                  <v-card-actions>
                    <v-btn
                      type="submit"
                      color="primary"
                      :loading="loading"
                      large
                      class="mb-5 px-12 mx-auto"
                      ><v-icon left>mdi-login</v-icon>Alterar
                    </v-btn>

                    <!--Retorno da alteração de senha -->
                    <v-dialog v-model="alert" width="500">
                      <v-card color="green" dark>
                        <v-card-title>Sucesso!</v-card-title>
                        <v-card-text class="mt-5">
                          Sua senha foi alterada! :)
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn text @click="$router.replace('/login')">
                            FAZER LOGIN COM A SENHA NOVA
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>

                    <!--Validando link do token -->
                    <v-dialog v-model="globalLoading" persistent width="300">
                      <v-card color="primary" dark>
                        <v-card-text>
                          Validando link
                          <v-progress-linear
                            indeterminate
                            color="white"
                            class="mb-0"
                          ></v-progress-linear>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  </v-card-actions>

                  <v-row align="center" justify="center">
                    <v-col class="text-center">
                      <router-link to="/login">Lembrei minha senha</router-link>
                    </v-col>
                  </v-row>
                </v-card>
              </v-form>
            </ValidationObserver>
          </v-col>
        </v-row>
      </v-container>

      <v-footer absolute class="text-center">
        <v-card-text class="py-2">
          Powered by
          <strong>Core Coding</strong>
          &copy;{{ new Date().getFullYear() }}
        </v-card-text>
      </v-footer>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "resetting_password",
  data: () => ({
    alert: false,
    password: "",
    message: "",
    loading: false,
    globalLoading: false,
    show1: false,
    show2: false,
    confirm_password: ""
  }),
  methods: {
    recover() {
      this.$refs.forms.validate().then(r => {
        if (r) {
          this.loading = true;
          this.message = "";

          this.$http
            .post("/auth/change_password", {
              new_password: this.password,
              token: this.token_number,
              new_password: this.confirm_password
            })
            .then(response => {
              this.alert = true;
              this.message = response.data.message;
            })
            .catch(error => {
              switch (error.response.status) {
                case 422: //Validação do formulário
                  this.$refs.forms.setErrors(error.response.data.errors);
                  break;
                case 400: //Validação do token
                  this.$store.commit("setMessage", error.response.data.message);
                  this.$router.replace("/login");
                  break;
                default:
                  //Demais falhas do sistema
                  this.message =
                    "Algo de errado aconteceu, tente novamente mais tarde.";
                  break;
              }
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          this.message = "";
        }
      });
    },

    getT_number() {
      return this.$route.params["token"];
    }
  },
  created() {
    this.globalLoading = true;

    this.$http
      .post("/auth/validate_token", {
        token: this.token_number
      })
      .then(response => {
        this.globalLoading = false;
        const valid = response.data.valid;

        if (valid == false) {
          this.$store.commit("setMessage", "Link inválido");
          this.$router.replace("/login");
        }
      });
  },
  computed: {
    token_number: function() {
      return this.getT_number();
    }
  }
};
</script>

<style scoped></style>
